<template>
    <div>
        <v-layout column :class="{'pa-3': $vuetify.breakpoint.xs, 'pa-4': $vuetify.breakpoint.smAndUp}">
            <v-layout v-if="content.author" row wrap
                      justify-space-between
                      align-center
            >

                <router-link class="flex ideas-item__user link--anchor" :to="{name: 'profile_other', params: {id: content.author.id}}" :class="{'mt-2 pr-0': $vuetify.breakpoint.smAndDown, 'pr-4': $vuetify.breakpoint.mdAndUp}">
                    <div class="ideas-item__user-avatar">
                        <img :src="content.author.avatar | avatar" alt="avatar" width="40px"
                             height="40px"
                        >
                    </div>
                    <v-layout column align-start>
                        <span>{{ content.author.name }}</span>
                        <v-layout align-center>
                            <img :src="content.author.chevron" alt="chevron" class="mt-1"
                                 width="30px" height="25px"
                            >
                            <div class="grey-text">{{ $t(content.author.rank) }}</div>
                        </v-layout>
                    </v-layout>
                </router-link>
                <v-flex xs12 sm5 :class="{'mt-3': $vuetify.breakpoint.xs}">
                    <v-layout text-sm-right :class="{'justify-end': $vuetify.breakpoint.smAndUp}">
                        <div class="mr-2">{{ content.date | day }}</div>
                        <div class="grey-text">{{ content.date | time }}</div>
                    </v-layout>
                </v-flex>
            </v-layout>
            <div class="mt-3 mb-3">{{ content.text }}</div>
            <linkIcon v-if="content.author && content.author.id == user.id" icon="edit" size="20"
                      @click.native="open_edit_modal(content.id)"
            >{{$t("Редактировать")}}</linkIcon>
        </v-layout>
    </div>
</template>

<script>
import linkIcon from '@/components/ui/links/with_icon/link_sprite_icon';
import {mapState, mapGetters, mapMutations, mapActions} from 'vuex';
import dayjs from 'dayjs';
export default {
  components: {
    linkIcon,
  },
  props: {
    content: {
      type: Object,
    },
  },
  computed: {
    page: {
      get() {
        return this.selected_page;
      },
      set($event) {
        return this.SET_SELECTED_PAGE($event);
      },
    },
    ...mapGetters('profile/user', [
      'user',
    ]),
    ...mapState('common', [
      'url',
    ]),
    ...mapGetters('news_main/detail', ['comments', 'modal_comment_edit', 'add_comment_modal', 'selected_number', 'selected_page', 'comments_paginated']),
  },
  methods: {
    ...mapActions('news_main/detail', ['show_number']),
    ...mapMutations('news_main/detail', [
      'OPEN_MODAL',
      'CLOSE_MODAL',
      'SET_SELECTED_PAGE',
      'SET_EDITED_ID',
      'SET_COMMENTS',
    ]),
    open_edit() {
      this.OPEN_MODAL('modal_comment_edit');
    },
    open_edit_modal(id) {
      this.OPEN_MODAL('modal_comment_edit');
      this.SET_EDITED_ID(id);
    },
  },

};
</script>
